export function getISODate(date: string | null) {
  if (!date) return ''

  const currentDate = new Date(date)

  const year = currentDate.getFullYear()
  const month = (currentDate.getMonth() + 1).toString().padStart(2, '0') // Months are zero-based
  const day = currentDate.getDate().toString().padStart(2, '0')

  const formattedDate = `${year}-${month}-${day}`

  return formattedDate
}
